/* eslint-disable max-len */
export const reportMessages = {
    'Report.Header.createdOn': 'Created On',
    'Report.Header.period': 'Period',
    'Report.Header.preparedFor': 'Prepared For',
    'Report.name': 'Report Name',
    'Report.no_data_notice':
        'No data to report (yet!). Try adjusting your filters to get results, or check back later once more data is available.',
    'Report.period': '{{period}} Period',
    'Report.select_clients': 'Select which clients to report on',
    'ReportBuilder.exclude_tags': 'Exclude tags',
    'ReportBuilder.no_tags': 'Include applications without tags',
    'Reports.accountsInventory.checkbox.AccountsInventory':
        'Accounts Inventory Report',
    'Reports.accountsInventory.checkbox.AccountsInventory.subOption.AccountOverview':
        'Account Overview',
    'Reports.accountsInventory.checkbox.AccountsInventory.subOption.AccountSummary':
        'Account Summary',
    'Reports.accountsInventory.description':
        'Centralize visibility into all user, shared, and service accounts to reduce risk and support secure account lifecycle management.',
    'Reports.AccountsInventory.personal': 'Personal Account',
    'Reports.AccountsInventory.personalAccounts': 'Personal Accounts',
    'Reports.AccountsInventory.service': 'Service Account',
    'Reports.AccountsInventory.serviceAccounts': 'Service Accounts',
    'Reports.AccountsInventory.shared': 'Shared Account',
    'Reports.AccountsInventory.sharedAccounts': 'Shared Accounts',
    'Reports.accountsInventory.title': 'Accounts Inventory Report',
    'Reports.AccountsInventory.total': 'Total Accounts',
    'Reports.AccountsInventory.work': 'Work Account',
    'Reports.AccountsInventory.workAccounts': 'Work Accounts',
    'Reports.admin': 'Client',
    'Reports.adminLevelReports': 'Client Level Reports',
    'Reports.adoption.allUsersInOrg.activeInactive':
        'All Users In Organization, Active Vs. Inactive',
    'Reports.adoption.bottom5Users': 'Bottom 5 Users',
    'Reports.adoption.dailyAveargeOverDays':
        'Daily Average over {{totalDays}} days',
    'Reports.adoption.dailyBreakdown.multipleApps.forPeriod':
        'Daily Breakdown for Multiple Applications between <StartDate/> and <EndDate/>',
    'Reports.adoption.dailyBreakdown.singleApp.forPeriod':
        'Daily Breakdown for {{appName}} between <StartDate/> and <EndDate/>',
    'Reports.adoption.forApp.forMonthly':
        'Product Adoption Report For {{appName}} for {{month}}',
    'Reports.adoption.forApp.forPeriod':
        'Product Adoption Report For {{appName}} between <StartDate/> and <EndDate/>',
    'Reports.adoption.hms.sec.usageOverNumberOvertotalDays':
        '(avg. <HMS/> / day)',
    'Reports.adoption.multipleApps':
        'Product Adoption Report for Multiple Applications',
    'Reports.adoption.orgOverview': 'Organizational Overview',
    'Reports.adoption.orgOverview.item1.multipleApps':
        'Between <StartDate/> and <EndDate/>, {{activeUsers}} users were active in multiple applications and {{inactiveUsers}} users were not.',
    'Reports.adoption.orgOverview.item1.singleApp':
        'Between <StartDate/> and <EndDate/>, {{activeUsers}} users were active in {{appName}} and {{inactiveUsers}} were not.',
    'Reports.adoption.orgOverview.item2':
        'Of the {{activeUsers}} active users, there were',
    'Reports.adoption.orgOverview.item2.subitems': '{{value}} {{type}} users',
    'Reports.adoption.selectApps':
        'Please select an application and re-run this report.',
    'Reports.adoption.top5Users': 'Top 5 Power Users',
    'Reports.adoption.usageVsDaily.multipleApps.forPeriod':
        'Usage vs. Daily Users for Multiple Applications between <StartDate/> and <EndDate/>',
    'Reports.adoption.usageVsDaily.singleApp.forPeriod':
        'Usage vs. Daily Users for {{appName}} between <StartDate/> and <EndDate/>',
    'Reports.adoption.userBreakdown.multipleApps.forPeriod':
        'User Breakdown for Multiple Applications between <StartDate/> and <EndDate/>',
    'Reports.adoption.userBreakdown.singleApp.forPeriod':
        'User Breakdown for {{appName}} between <StartDate/> and <EndDate/>',
    'Reports.advanced_setup': 'Advanced Report Setup',
    'Reports.advancedOptions.disableBrowsers': 'Remove browsers from report',
    'Reports.advancedOptions.disableInactive': 'Remove inactivity from report',
    'Reports.advancedOptions.disablePersonal':
        'Remove personal applications from report',
    'Reports.advancedOptions.disableUnclassified':
        'Remove unclassified applications from report',
    'Reports.advancedOptions.excludeDormant':
        'Remove dormant accounts from report',
    'Reports.advancedOptions.excludePersonalAccounts':
        'Remove personal accounts from report',
    'Reports.application.checkbox.Map': 'Application Map Report',
    'Reports.application.checkbox.Map.subOption.Breakdown': 'Breakdown',
    'Reports.application.checkbox.Map.subOption.Overview': 'Overview',
    'Reports.application.description':
        'Visualize which applications are most often used together to uncover integration, automation, and workflow optimization opportunities.',
    'Reports.application.title': 'Application Map Report',
    'Reports.applicationFunnel.checkbox.All': 'All',
    'Reports.applicationFunnel.checkbox.Breakdown': 'Breakdown',
    'Reports.applicationFunnel.overview': 'Overview',
    'Reports.applicationFunnel.overviewBreakdown': 'Overview',
    'Reports.applicationOverlap.checkbox.ApplicationOverlap':
        'Application Overlap Report',
    'Reports.applicationOverlap.checkbox.ApplicationOverlap.subOption.CategoryBreakdown':
        'Category Breakdown',
    'Reports.applicationOverlap.checkbox.ApplicationOverlap.subOption.CategoryOverview':
        'Category Overview',
    'Reports.applicationOverlap.description':
        'Identifies overlapping applications that serve the same purpose, highlighting consolidation opportunities to reduce costs, eliminate redundancies, and streamline SaaS use.',
    'Reports.applicationOverlap.title': 'Application Overlap Report',
    'Reports.applicationOverlapReport.categoryBreakdown.description':
        'A detailed view of discovered applications grouped by sub-category that may be providing similar functionality helping identify redundancies, usage trends, and potential security concerns. Users and Usage is based on the timeframe selected.',
    'Reports.applicationOverlapReport.categoryBreakdown.title':
        'Category Breakdown',
    'Reports.applicationOverlapReport.categoryOverview.description':
        'Distribution of application categories that share overlapping tools. Each segment represents a distinct category and its proportion reflects the number of sub-categories with overlapping tools.',
    'Reports.ApplicationOverlapReport.categoryOverview.title':
        'Category Overview',
    'Reports.ApplicationReport.map_breakdown': 'Related Applications Breakdown',
    'Reports.ApplicationReport.map_overview': 'Application Map Top 20',
    'Reports.ApplicationReport.map_overview_usage':
        'Related Applications Usage Comparison (Top 20)',
    'Reports.ApplicationReport.map_overview_users':
        'Related Applications User Comparison (Top 20)',
    'Reports.applications.allApplicationsSelected': 'All applications selected',
    'Reports.applications.noApplicationsSelected': 'No applications selected',
    'Reports.applications.selected': 'Applications Selected',
    'Reports.applicationsToReportOn': 'Applications to Report On',
    'Reports.availableReports': 'Available Reports',
    'Reports.browser.checkbox.Browser': 'Browser Account Security Reports',
    'Reports.browser.checkbox.Browser.subOption.Overview': 'Overview',
    'Reports.browser.description':
        'Identify users logging into browsers with personal email accounts, exposing risks of cached data leaks and highlighting the need for secure profile practices.',
    'Reports.Browser.personal_count':
        'Active Users with Personal Browser Profiles',
    'Reports.Browser.personal_percent':
        '% of Users with Personal Browser Profiles',
    'Reports.Browser.personal_profile': 'Personal Browser Profile',
    'Reports.Browser.profile_breakdown': 'User Browser Profile Breakdown',
    'Reports.browser.title': 'Browser Account Security Report',
    'Reports.Browser.users_with_personal':
        'Users with Personal Browser Profiles',
    'Reports.Browser.users_without_personal':
        'Users without Personal Browser Profiles',
    'Reports.businessOwner': 'Business Owner',
    'Reports.businessOwner.checkbox.BusinessOwner': 'Business Owner Reports',
    'Reports.businessOwner.checkbox.BusinessOwner.subOption.ApplicationBreakdown':
        'Application Breakdown',
    'Reports.businessOwner.description':
        'Compare SaaS contracts against actual user activity to identify wasted spend, low adoption, and optimization opportunities by business owner.',
    'Reports.businessOwner.title': 'Business Owner Report',
    'Reports.BusinessOwnerReport.business_owner_application_breakdown':
        'Application Breakdown',
    'Reports.BusinessOwnerReport.first_month': '1st Month',
    'Reports.BusinessOwnerReport.quarterUsage': 'Quarter Usage',
    'Reports.BusinessOwnerReport.second_month': '2nd Month',
    'Reports.BusinessOwnerReport.third_month': '3rd Month',
    'Reports.CategoryReport.category_breakdown': 'Category Breakdown',
    'Reports.CategoryReport.category_overview': 'Category Overview',
    'Reports.cbr.description':
        'Track application usage trends and uncover overlapping tools to identify consolidation opportunities and reduce risk.',
    'Reports.cbr.title': 'Customer Business Report',
    'Reports.checkbox.AccountsInventory': 'Accounts Inventory Report',
    'Reports.checkbox.Discovery': 'Discovery Outcome Report',
    'Reports.clientsToReportOn': 'Clients to Report On',
    'Reports.collapse_all': 'Collapse All',
    'Reports.confirmToDeleteScheduledReport.message':
        'Are you sure you want to delete {{reportName}}? This action cannot be undone.',
    'Reports.confirmToDeleteScheduledReport.title': 'Delete Scheduled Report',
    'Reports.Contracts.activeUsers': 'Active Users',
    'Reports.Contracts.all': 'All Contracts',
    'Reports.contracts.checkbox.Contracts': 'Contract Insights Report',
    'Reports.contracts.checkbox.Contracts.subOption.ApplicationUserDetails':
        'Application User Details',
    'Reports.contracts.checkbox.Contracts.subOption.Overview': 'Overview',
    'Reports.Contracts.contractDate': 'Contract Date',
    'Reports.contracts.description':
        'Track SaaS contract terms, renewal dates, and user adoption to align spending with actual usage and reduce wasted costs.',
    'Reports.Contracts.email': 'Email',
    'Reports.Contracts.firstDetected': 'First Detected',
    'Reports.Contracts.lastUsage30DaysAgo':
        'Last usage was more than 30 days ago.',
    'Reports.Contracts.lastUsed': 'Last Used',
    'Reports.Contracts.monthlyContractValue':
        'Monthly Contract Value by this App',
    'Reports.Contracts.monthToMonth': 'Month to Month',
    'Reports.Contracts.noEventMatch': 'No contracts match the chosen criteria.',
    'Reports.Contracts.percentOfTotalMonthlyValue':
        '<Percent/> of the total monthly value',
    'Reports.Contracts.renewal': 'Renewal',
    'Reports.Contracts.renewalContract': 'Renewal Contract',
    'Reports.Contracts.renewalContracts': 'Renewal Contracts',
    'Reports.Contracts.subscribedUsers': 'Subscribed Users',
    'Reports.Contracts.tableByType': 'Contracts Table by Type',
    'Reports.contracts.title': 'Contract Insights Report',
    'Reports.Contracts.totalContracts': 'Total Contracts',
    'Reports.Contracts.totalContractValue': 'Total Contract Value',
    'Reports.Contracts.totalMonthlyValue': 'Total Monthly Value',
    'Reports.Contracts.type': 'Type',
    'Reports.Contracts.upcomingContracts': 'Upcoming Contracts',
    'Reports.Contracts.user': 'User',
    'Reports.Contracts.usersDetails': 'Users Details for All Applications',
    'Reports.Contracts.usersDetailsAppBreakdown': 'Application Breakdown',
    'Reports.Contracts.usersDetected': 'Users Detected',
    'Reports.createNewReportToEdit':
        'If you want to edit the scheduled report, please create a new one.',
    'Reports.Device.detailed_usage': 'Detailed Device Application Usage',
    'Reports.discovery.checkbox.Discovery': 'Discovery Outcome',
    'Reports.discovery.checkbox.Discovery.subOption.ApplicationBreakdown':
        'Application Breakdown',
    'Reports.discovery.checkbox.Discovery.subOption.Overview': 'Overview',
    'Reports.discovery.checkbox.Discovery.subOption.OverviewBreakdown':
        'Overview Breakdown',
    'Reports.discovery.checkbox.Discovery.subOption.RiskAnalysis':
        'Risk Analysis',
    'Reports.discovery.description':
        'Gain a comprehensive view of discovered SaaS applications, including risk levels, ownership, and lifecycle stage, to drive informed security and compliance decisions.',
    'Reports.discovery.Discovery.subOptions.options.expandUserDetails':
        'Expand User Details',
    'Reports.discovery.title': 'Discovery Outcome Report',
    'Reports.discoveryReport.applicationBreakdown.description':
        'This is an entire breakdown of every application that is discovered and mapped. The purpose of this report is to overview the entire SaaS ecosystem in your environment. All the data collected is based off of the survey process.',
    'Reports.discoveryReport.businessOwner.assigned': 'Assigned',
    'Reports.discoveryReport.businessOwner.breakdown':
        'Business Owner Assignment Breakdown',
    'Reports.discoveryReport.businessOwner.description':
        'This is a breakdown of all your applications and which ones have business owners and those who do not. Immediate remediation is recommended to have a business owner for all applications.',
    'Reports.discoveryReport.businessOwner.notAssigned': 'Not Assigned',
    'Reports.discoveryReport.businessOwnerAssignmentOverview':
        'Business Owner Assignment Overview',
    'Reports.discoveryReport.businessPurpose.label': 'Business Purpose:',
    'Reports.discoveryReport.discoveryApplicationBreakdown':
        'Application Breakdown',
    'Reports.discoveryReport.discoveryOverview': 'Overview',
    'Reports.discoveryReport.noPurposeSet': 'No Purpose Set',
    'Reports.discoveryReport.overview.description':
        'This is an entire application breakdown of your businesses web & desktop-based tools. This survey represents all the data we have collected so far.',
    'Reports.discoveryReport.overview.title':
        'Application Overview & Application Discovery Outcomes',
    'Reports.discoveryReport.risk.label': 'Risk:',
    'Reports.discoveryReport.riskAnalysis.description':
        'Application Risks are determined by the level of risk applications bring to an organization. These are determined based off of the severity of impact an application can have to an organization. Higher risks do not indicate that these platforms should not be included, however they do present platforms that should be evaluated to ensure no risk is being brought to an organization.',
    'Reports.discoveryReport.riskAnalysis.title': 'Application Risk Analysis',
    'Reports.discoveryReport.statusAssignment.breakdown':
        'Lifecycle Stage Breakdown',
    'Reports.discoveryReport.statusAssignment.overview':
        'Lifecycle Stage Overview',
    'Reports.discoveryReport.tagAssignment.breakdown':
        'Tag Assignment Breakdown',
    'Reports.editReport': 'Edit Report',
    'Reports.editReportDescription':
        'Make changes to your report settings. Re-run the report to view the updates.',
    'Reports.error_one_report': 'Please select at least one report to be ran.',
    'Reports.error_select_business_owner': 'Please select a business owner.',
    'Reports.errorGettingData': 'Could not retrieve report information.',
    'Reports.expand_all': 'Expand All',
    'Reports.expand_user_details': 'Expand User Details',
    'Reports.exportedReport': 'Exported Report',
    'Reports.form.name.label': 'Report Name',
    'Reports.form.notes.label': 'Description',
    'Reports.form.period.label': 'Report Cadence',
    'Reports.form.recipients.helperText': 'User or Email Address',
    'Reports.form.recipients.label': 'Send Report To',
    'Reports.groups.allGroupsSelected': 'All groups selected',
    'Reports.groups.selected': 'Groups Selected',
    'Reports.LibraryReport.library_overview': 'Library Overview',
    'Reports.microsoftOfficeOverlap.applicationOverviewBreakdown.title':
        'Application Overview Breakdown',
    'Reports.microsoftOfficeOverlap.checkbox.MicrosoftOfficeOverlap':
        'Microsoft Office Overlap Reports',
    'Reports.microsoftOfficeOverlap.checkbox.MicrosoftOfficeOverlap.subOption.NoOverlapBreakdown':
        'No Overlap Overview Breakdown',
    'Reports.microsoftOfficeOverlap.checkbox.MicrosoftOfficeOverlap.subOption.Overview':
        'Overview',
    'Reports.microsoftOfficeOverlap.checkbox.MicrosoftOfficeOverlap.subOption.OverviewBreakdown':
        'Overview Breakdown',
    'Reports.microsoftOfficeOverlapReport.currentlyUsed':
        '<MakeItBold>Currently Used</MakeItBold> indicates the the application had usage during the time period.',
    'Reports.microsoftOfficeOverlapReport.description':
        'Identify applications in use that overlap with Microsoft Office offerings to consolidate tools, and optimize licensing.',
    'Reports.microsoftOfficeOverlapReport.noOverlapBreakdown.description':
        'This is all Microsoft Office Applications that we identified have no usage and no overlap with applications currently in use in your environment.',
    'Reports.microsoftOfficeOverlapReport.noOverlapBreakdown.title':
        'Microsoft Office Overlap No Overlap Overview Breakdown',
    'Reports.microsoftOfficeOverlapReport.noOverlapOverviewBreakdown.description':
        'This is all Microsoft Office Applications that we identified have no usage and no overlap with applications currently in use in your environment.',
    'Reports.microsoftOfficeOverlapReport.noOverlapOverviewBreakdown.title':
        ' No Application Usage and No Overlap Overview',
    'Reports.microsoftOfficeOverlapReport.overview.description':
        'This is a quick overview of all Microsoft Office Applications that we identified have overlap with applications currently in use in your environment.',
    'Reports.microsoftOfficeOverlapReport.overview.title':
        'Microsoft Office Overlap Overview',
    'Reports.microsoftOfficeOverlapReport.overviewBreakdown.description':
        'This is all Microsoft Office Applications that we identified have either usage or no usage and have overlap with applications currently in use in your environment.',
    'Reports.microsoftOfficeOverlapReport.overviewBreakdown.title':
        'Microsoft Office Overlap Overview Breakdown',
    'Reports.microsoftOfficeOverlapReport.title':
        'Microsoft Office Overlap Report',
    'Reports.navigation': 'Navigation',
    'Reports.navigationDescription':
        'Quickly move between sections of your report. Jump to key insights, data summaries, and detailed breakdowns without scrolling.',
    'Reports.nextDeliveryTime': 'Next Delivery Time',
    'Reports.offboard.checkbox.UserOffboard': 'User Offboard',
    'Reports.offboard.description':
        'Ensure secure and complete offboarding by tracking user access, connected applications, and accounts across the SaaS environment.',
    'Reports.offboard.title': 'Offboard Report',
    'Reports.organizational.checkbox.Category': 'Category Reports',
    'Reports.organizational.checkbox.Category.subOption.Usage':
        'Usage And Overlap',
    'Reports.organizational.checkbox.Category.subOption.UsageBreakdown':
        'Usage Breakdown',
    'Reports.organizational.checkbox.Library': 'Library Reports',
    'Reports.organizational.checkbox.Library.subOption.Overview':
        'Library Changes',
    'Reports.organizational.checkbox.Usage': 'Usage Reports',
    'Reports.organizational.checkbox.Usage.subOption.DailyBreakdown':
        'Daily Breakdown',
    'Reports.organizational.checkbox.Usage.subOption.Overview': 'Overview',
    'Reports.organizational.checkbox.Usage.subOption.OverviewBreakdown':
        'Overview Breakdown',
    'Reports.organizational.checkbox.Usage.subOption.VsAdoption':
        'Usage vs Adoption',
    'Reports.organizational.description':
        'Overview of organizational application usage, adoption trends, and category-level insights to spot growth, sprawl, and optimization opportunities.',
    'Reports.organizational.title': 'Organizational Usage Report',
    'Reports.organizationalReport.vsAdoption.description':
        'A comprehensive view of user engagement alongside the growth in application footprint. This chart showcases the average application usage per use (total apps discovered by total users) alongside the daily count of newly discovered applications based on the time frame selected. Use this to provide visibility into software growth, user engagement and potential trends of sprawl or underutilization.',
    'Reports.partner': 'Partner',
    'Reports.partnerApplicationOverview.checkbox.ApplicationsUsed':
        'Applications Used Report',
    'Reports.partnerApplicationOverview.checkbox.ApplicationsUsed.subOption.ApplicationBreakdown':
        'Application Breakdown',
    'Reports.partnerApplicationOverview.checkbox.ApplicationsUsed.subOption.Breakdown':
        'Breakdown',
    'Reports.partnerApplicationOverview.checkbox.ApplicationsUsed.subOption.OverviewBreakdown':
        'Overview Breakdown',
    'Reports.partnerApplicationOverview.checkbox.ApplicationUsage':
        'Application Usage Report',
    'Reports.partnerApplicationOverview.checkbox.ApplicationUsage.subOption.ApplicationBreakdown':
        'Application Breakdown',
    'Reports.partnerApplicationOverview.checkbox.ApplicationUsage.subOption.Breakdown':
        'Breakdown',
    'Reports.partnerApplicationOverview.checkbox.ApplicationUsage.subOption.OverviewBreakdown':
        'Overview Breakdown',
    'Reports.partnerApplicationOverview.description':
        'Gain visibility into application adoption by category and top apps by user activity across all clients. Identify trends, uncover growth opportunities, and focus management efforts where they matter most',
    'Reports.partnerApplicationOverview.title':
        'Partner Application Overview Report',
    'Reports.PartnerApplicationOverviewReport.application_breakdown_by_user_count':
        'Application Breakdown by User Count',
    'Reports.PartnerApplicationOverviewReport.application_usage_by_category_breakdown':
        'Applications Used During Quarter by Category Breakdown',
    'Reports.PartnerApplicationOverviewReport.application_usage_by_category_overview':
        'Applications Used by Category Overview',
    'Reports.partnerApplicationOverviewReport.applicationBreakdown.description':
        'Applications are stacked ranked by the number of unique users within the quarter.',
    'Reports.partnerApplicationOverviewReport.applicationBreakdown.description.detail':
        'Each application and number of users per month and quarter can be broken down to show the number of users from each client.',
    'Reports.partnerApplicationOverviewReport.breakdown.description':
        "Each application category and the number of applications  used within that category for each month of the quarter, across all of your clients' tenants, are represented below.",
    'Reports.partnerApplicationOverviewReport.overviewBreakdown.description':
        "Each application category and the number of applications used within that category for the quarter selected, across all of your clients' tenants, are represented below.",
    'Reports.partnerApplicationUsage.checkbox.TopApplicationsUsed':
        'Applications Used',
    'Reports.partnerApplicationUsage.checkbox.TopApplicationsUsed.subOption.TopApplicationsUsedLastWeek':
        'Top Applications Used Last Week',
    'Reports.partnerBreachImpact.checkbox.ClientImpact': 'Client Impact',
    'Reports.partnerBreachImpact.checkbox.ClientImpact.subOption.Breakdown':
        'Breakdown',
    'Reports.partnerBreachImpact.description':
        'Summarized vendor security incidents, their impact, and recommended actions to protect your clients.',
    'Reports.partnerBreachImpact.title': 'Vendor Incident Report',
    'Reports.partnerClientDeploymentStage.checkbox.ClientStages':
        'Applications Used',
    'Reports.partnerClientDeploymentStage.checkbox.ClientStages.subOption.Breakdown':
        'Breakdown',
    'Reports.partnerClientDeploymentStage.checkbox.ClientStages.subOption.OverviewBreakdown':
        'Overview Breakdown',
    'Reports.partnerLevelReports': 'Partner Level Reports',
    'Reports.partnerUsers.checkbox.PartnerUsers':
        'Partner User Inventory Report',
    'Reports.partnerUsers.checkbox.PartnerUsers.subOption.Overview': 'Overview',
    'Reports.partnerUsers.description':
        'View and analyze user and device inventory across your client base to track usage and security alignment.',
    'Reports.partnerUsers.title': 'Partner User Inventory Report',
    'Reports.period.customQuarter': 'Custom Quarter',
    'Reports.period.daily': 'Daily',
    'Reports.period.description.customQuarter':
        'Reports follows a custom 90-day schedule starting from the month you created the report.',
    'Reports.period.description.daily': 'Report is sent each day.',
    'Reports.period.description.monthly':
        'Report is sent on the first of every month.',
    'Reports.period.description.quarterly':
        'Report is sent based on standard business quarters, beginning January.',
    'Reports.period.description.weekly': 'Report is sent every Monday.',
    'Reports.period.monthly': 'Monthly',
    'Reports.period.period': 'Period',
    'Reports.period.quarterly': 'Quarterly',
    'Reports.period.weekly': 'Weekly',
    'Reports.productAdoption.checkbox.ProductAdoption':
        'Product Adoption Report',
    'Reports.productAdoption.checkbox.ProductAdoption.subOption.Overview':
        'Overview Breakdown',
    'Reports.productAdoption.description':
        'Track product adoption trends across applications, highlighting power users, low adopters, and daily engagement to drive targeted enablement.',
    'Reports.productAdoption.title': 'Product Adoption Report',
    'Reports.prompt_crunching_report':
        'Currently Crunching Your Personalized Report!',
    'Reports.qbr.checkbox.QBRFirst': ' All Reports',
    'Reports.qbr.checkbox.QBRFirst.subOption.AppClassificationScore':
        'Application Classification Score',
    'Reports.qbr.checkbox.QBRFirst.subOption.AppOverlapScore':
        'Application Overlap Score',
    'Reports.qbr.checkbox.QBRFirst.subOption.Insights': 'Insights',
    'Reports.qbr.checkbox.QBRFirst.subOption.ManagedAppScore':
        'Managed Application Score',
    'Reports.qbr.checkbox.QBRFirst.subOption.Notes': 'Notes & Recommendations',
    'Reports.qbr.checkbox.QBRFirst.subOption.SaaSSophisticationScore':
        'SaaS Health Score',
    'Reports.qbr.checkbox.QBRFirst.subOption.ScoreOverviewAndGraph':
        'Score Overview & SaaS Health Line Graph',
    'Reports.qbr.checkbox.QBRFirst.subOption.ShadowITScore':
        'Unclassified Application Score',
    'Reports.qbr.checkbox.QBRFirst.subOption.UnapprovedAppScore':
        'Unapproved Application Score',
    'Reports.qbr.description':
        'Track quarterly application usage trends and uncover overlapping tools to identify consolidation opportunities and reduce risk.',
    'Reports.qbr.title': 'Quarterly Business Report',
    'Reports.remove_unanalyzed': 'Remove unanalyzed applications from report',
    'Reports.ReportBuilder.all': 'All',
    'Reports.ReportBuilder.all_users_and_groups': 'All users / groups',
    'Reports.ReportBuilder.applications_platforms': 'Applications platforms',
    'Reports.ReportBuilder.approved': 'Approved',
    'Reports.ReportBuilder.certain_applications': 'Select applications',
    'Reports.ReportBuilder.certain_categories': 'Select categories',
    'Reports.ReportBuilder.certain_groups': 'Select certain groups',
    'Reports.ReportBuilder.certain_management_stage': 'Select management stage',
    'Reports.ReportBuilder.certain_statuses': 'Select lifecycle stage',
    'Reports.ReportBuilder.certain_users': 'Select certain users',
    'Reports.ReportBuilder.certainSubCategories': 'Select subcategories',
    'Reports.ReportBuilder.dates':
        'Select a start and end date. Maximum range: 12 months.',
    'Reports.ReportBuilder.narrow_application':
        'Select which application to report on',
    'Reports.ReportBuilder.narrow_applications':
        'Select which applications to report on',
    'Reports.ReportBuilder.narrow_status':
        'Select which application lifecycle stage to report on',
    'Reports.ReportBuilder.narrow_users': 'Select which user(s) to report on',
    'Reports.ReportBuilder.not_approved': 'Unapproved',
    'Reports.ReportBuilder.not_configured': 'Not configured',
    'Reports.ReportBuilder.overview_matrix_tags':
        'Select tags to show in overview matrix',
    'Reports.ReportBuilder.select.application': 'Select application',
    'Reports.ReportBuilder.select.applications': 'Select application(s)',
    'Reports.ReportBuilder.select.businessOwner': 'Select business owner',
    'Reports.ReportBuilder.select.end': 'Select your ending period',
    'Reports.ReportBuilder.select.period': 'Select your report period',
    'Reports.ReportBuilder.select.start': 'Select your starting period',
    'Reports.ReportBuilder.select.subReport': 'Select your sub-report options',
    'Reports.ReportBuilder.select.user': 'Select which user to report on',
    'Reports.ReportBuilder.select.weekly':
        'Select a week to run your report on',
    'Reports.ReportBuilder.tooManyAppsWarning':
        'Reports may not render well with more than 5 applications selected for the Product Adoption report.',
    'Reports.reportDetails': 'Report Details',
    'Reports.ReportSummary.advanced_report_details': 'Advanced Report Details',
    'Reports.ReportSummary.sub_reports': 'Sub-Reports',
    'Reports.reportType': 'Report Type',
    'Reports.run_report': 'Run Report',
    'Reports.save_and_schedule': 'Save and Schedule Report',
    'Reports.save_and_schedule.body':
        'Any report that is saved and scheduled here can be found on the Scheduled Reports page.',
    'Reports.Schedule.error': 'Error scheduling report.',
    'Reports.Schedule.error_select_user':
        'You must select a user/email to send the report to.',
    'Reports.Schedule.select_user_email':
        'Select User OR Enter Email to Send Report To',
    'Reports.Schedule.success': 'Your report has been saved.',
    'Reports.ScheduledReport.error_loading_reports':
        'Issue loading scheduled reports.',
    'Reports.ScheduledReport.error_removing_report':
        'There was an issue removing this report from your dashboard.',
    'Reports.ScheduledReport.errorMessage':
        'Failed to schedule report. Please try again.',
    'Reports.ScheduledReport.success_remove':
        'Successfully removed this report from your dashboard.',
    'Reports.ScheduledReport.successMessage': 'Report scheduled successfully.',
    'Reports.ScheduledReport.view_full_report':
        'View Full Report Configuration',
    'Reports.scheduledReports': 'Scheduled Reports',
    'Reports.scheduledReportsWithCount_one': 'Scheduled Report',
    'Reports.scheduledReportsWithCount_other': 'Scheduled Reports',
    'Reports.schedulePeriod': 'Schedule Period',
    'Reports.selectedApplications': 'Selected Applications',
    'Reports.selectedClients': 'Selected Clients',
    'Reports.selectedDate': 'Selected Date',
    'Reports.selectedPeriod': 'Selected Period',
    'Reports.selectedSubReports': 'Selected sub-reports Options',
    'Reports.selectedTags': 'Selected Tags',
    'Reports.selectedUsers': 'Selected Users',
    'Reports.sendEmail.descriptionLabel': 'Description',
    'Reports.sendEmail.errorInvalidEmails':
        'Please enter valid email addresses for all recipients.',
    'Reports.sendEmail.errorMessage':
        'Failed to send report. Please try again.',
    'Reports.sendEmail.errorSelectRecipients':
        'Please select at least one user or email address.',
    'Reports.sendEmail.recipientsLabel': 'User(s) or Email Address(es)',
    'Reports.sendEmail.subjectLabel': 'Subject',
    'Reports.sendEmail.successMessage': 'Report sent successfully.',
    'Reports.sendReportTo': 'Send Report To',
    'Reports.sendViaEmail': 'Send via Email',
    'Reports.shadowIT.checkbox.ShadowIT': 'Shadow IT Report',
    'Reports.shadowIT.checkbox.ShadowIT.subOption.Breakdown': 'Breakdown',
    'Reports.shadowIT.checkbox.ShadowIT.subOption.Overview': 'Overview',
    'Reports.shadowIT.checkbox.ShadowIT.subOption.OverviewBreakdown':
        'Overview Breakdown',
    'Reports.shadowIT.description':
        'Highlight applications and users introducing Shadow IT, with category-level insights to uncover unmanaged tools and potential security risks.',
    'Reports.shadowIT.overviewBreakdown': 'Overview Breakdown',
    'Reports.shadowIT.title': 'Shadow IT Report',
    'Reports.status.breakdown': 'Breakdown',
    'Reports.status.checkbox.ApplicationLifecycleStage':
        'Application Lifecycle Report',
    'Reports.status.checkbox.ApplicationLifecycleStage.subOption.Breakdown':
        'Breakdown',
    'Reports.status.checkbox.ApplicationLifecycleStage.subOption.Overview':
        'Overview',
    'Reports.status.checkbox.ApplicationLifecycleStage.subOption.OverviewBreakdown':
        'Overview Breakdown',
    'Reports.status.description':
        'Track the lifecycle stage of applications across the organization to distinguish approved, unapproved, and unmanaged tools, helping reduce Shadow IT and enforce governance.',
    'Reports.status.overview': 'Overview',
    'Reports.status.overviewBreakdown': 'Overview Breakdown',
    'Reports.status.title': 'Application Lifecycle Report',
    'Reports.subOption.AccountOverview': 'Account Overview',
    'Reports.subOption.AccountSummary': 'Account Summary',
    'Reports.subReportOptions': 'Sub-Report Options',
    'Reports.tags.allTagsSelected': 'All tags selected',
    'Reports.tags.noTagsSelected': 'No tags selected',
    'Reports.tags.selected': 'Tags Selected',
    'Reports.tenantName': 'Tenant Name',
    'Reports.Title.accountsInventory.report': 'Accounts Inventory Report',
    'Reports.Title.accountsInventory.report.setup':
        'Accounts Inventory Report Setup',
    'Reports.Title.application.report': 'Application Map Report',
    'Reports.Title.application.report.setup': 'Application Map Report Setup',
    'Reports.Title.applicationFunnel.report': 'Application Funnel Report',
    'Reports.Title.applicationFunnel.report.setup':
        'Application Funnel Report Setup',
    'Reports.Title.applicationOverlap.report': 'Application Overlap Report',
    'Reports.Title.applicationOverlap.report.setup':
        'Application Overlap Report Setup',
    'Reports.Title.browser': 'Browser Account Security',
    'Reports.Title.browser.report': 'Browser Account Security Report',
    'Reports.Title.browser.report.setup':
        'Browser Account Security Report Setup',
    'Reports.Title.businessOwner.report': 'Business Owner Report',
    'Reports.Title.businessOwner.report.setup': 'Business Owner Report Setup',
    'Reports.Title.cbr.report': 'Customer Business Review',
    'Reports.Title.cbr.report.setup': 'Customer Business Review Setup',
    'Reports.Title.contracts': 'Contract Insights',
    'Reports.Title.contracts.report': 'Contract Insights Report',
    'Reports.Title.contracts.report.setup': 'Contract Insights Report Setup',
    'Reports.Title.device.report': 'Device Report',
    'Reports.Title.device.report.setup': 'Device Report Setup',
    'Reports.Title.discovery.report': 'Discovery Outcome Report',
    'Reports.Title.discovery.report.setup': 'Discovery Outcome Report Setup',
    'Reports.Title.microsoftOfficeOverlap.report':
        'Microsoft Office Overlap Report',
    'Reports.Title.microsoftOfficeOverlap.report.setup':
        'Microsoft Office Overlap Report Setup',
    'Reports.Title.offboard.report': 'Offboard Report',
    'Reports.Title.offboard.report.setup': 'Offboard Report Setup',
    'Reports.Title.organizational.report': 'Organizational Usage Report',
    'Reports.Title.organizational.report.setup':
        'Organizational Usage Report Setup',
    'Reports.Title.partnerApplicationOverview.report':
        'Partner Application Overview Report',
    'Reports.Title.partnerApplicationOverview.report.setup':
        'Partner Application Overview Report Setup',
    'Reports.Title.partnerApplicationUsage.report':
        'Partner Application Usage Report',
    'Reports.Title.partnerApplicationUsage.report.setup':
        'Partner Application Usage Report Setup',
    'Reports.Title.partnerBreachImpact.report': 'Vendor Incident Report',
    'Reports.Title.partnerBreachImpact.report.setup':
        'Vendor Incident Report Setup',
    'Reports.Title.partnerClientDeploymentStage.report':
        'Partner Client Deployment Stage Report',
    'Reports.Title.partnerClientDeploymentStage.report.setup':
        'Partner Client Deployment Stage Report Setup',
    'Reports.Title.partnerUsers.report': 'Partner User Inventory Report',
    'Reports.Title.partnerUsers.report.setup':
        'Partner User Inventory Report Setup',
    'Reports.Title.productAdoption.report': 'Product Adoption Report',
    'Reports.Title.productAdoption.report.setup':
        'Product Adoption Report Setup',
    'Reports.Title.qbr.report': 'Quarterly Business Report',
    'Reports.Title.qbr.report.setup': 'Quarterly Business Report Setup',
    'Reports.Title.shadowIT.report': 'Shadow IT Report',
    'Reports.Title.shadowIT.report.setup': 'Shadow IT Report Setup',
    'Reports.Title.status.report': 'Application Lifecycle Report',
    'Reports.Title.status.report.setup': 'Application Lifecycle Report Setup',
    'Reports.Title.userApps': 'User Application Inventory Report',
    'Reports.Title.userApps.report': 'User Application Inventory Report',
    'Reports.Title.userApps.report.setup':
        'User Application Inventory Report  Setup',
    'Reports.type.accountsInventory': 'Accounts Inventory',
    'Reports.type.application': 'Application Map',
    'Reports.type.applicationOverlap': 'Application Overlap',
    'Reports.type.browser': 'Browser Account Security',
    'Reports.type.businessOwner': 'Business Owner',
    'Reports.type.cbr': 'Customer Business',
    'Reports.type.contracts': 'Contract Insights',
    'Reports.type.discovery': 'Discovery Outcome',
    'Reports.type.microsoftOfficeOverlap': 'Microsoft Office Overlap',
    'Reports.type.offboard': 'Offboard',
    'Reports.type.organizational': 'Organizational Usage',
    'Reports.type.partnerApplicationOverview': 'Application Overview',
    'Reports.type.partnerBreachImpact': 'Vendor Incident',
    'Reports.type.partnerUsers': 'Partner User Inventory',
    'Reports.type.productAdoption': 'Product Adoption',
    'Reports.type.qbr': 'Quarterly Business',
    'Reports.type.shadowIT': 'Shadow IT',
    'Reports.type.status': 'Application Lifecycle',
    'Reports.type.userApps': 'User Application',
    'Reports.UsageReport.adoption_and_usage': 'Application Adoption and Usage',
    'Reports.UsageReport.application_users': 'Application Users',
    'Reports.UsageReport.applications': 'Applications',
    'Reports.UsageReport.applicationsDiscovered': 'Applications Discovered',
    'Reports.UsageReport.average_usage': 'Average Usage (Usage / Users)',
    'Reports.UsageReport.averageUsagePerUser': 'Average Usage Per User (Hours)',
    'Reports.UsageReport.usage_breakdown': 'Usage Breakdown',
    'Reports.UsageReport.usage_daily_breakdown': 'Usage Daily Breakdown',
    'Reports.UsageReport.usage_overview': 'Usage Overview',
    'Reports.UsageReport.usageAdoption.table.subtitle':
        'This table lists all applications discovered in your environment during the selected time frame. Applications identified via Quick Scan may not yet show usage data, as this is collected retroactively. Usage metrics will appear once sufficient data has been gathered.',
    'Reports.UsageReport.usageHours': 'Usage (Hours)',
    'Reports.userApps.checkbox.UserApps': 'User Application Inventory Report',
    'Reports.userApps.checkbox.UserApps.subOption.Overview': 'Overview',
    'Reports.userApps.description':
        'Map each user to the applications they access across the business, providing full visibility for license tracking, access governance, and security oversight.',
    'Reports.userApps.title': 'User Application Inventory Report',
    'Reports.users.allUsersSelected': 'All users selected',
    'Reports.users.noUsersSelected': 'No users selected',
    'Reports.users.selected': 'Users Selected',
    'Reports.usersToReportOn': 'Users to report on',
    'Reports.view_advanced_setup': 'View Advanced Report Setup',
    'Reports.viewReportDetails': 'View Report Details',
    'Reports.viewScheduledReportSetup': 'View Scheduled Report Setup'
};
